
import { Component, Prop, Vue } from "vue-property-decorator";

const CLASS = "section-title";

@Component
export default class SectionTitle extends Vue {
  @Prop({ type: String, default: null }) readonly title: string;
  @Prop({ type: String, default: null }) readonly color: string;

  get classes() {
    const { color } = this;

    return {
      [`${CLASS}_color-${color}`]: color,
      [`${CLASS}_border`]: color,
    };
  }
}
